(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gr-sunglasses-image-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gr-sunglasses-image-swatches')) {
  const tileCss = `
    .gr-sunglasses-tile-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
    .gr-sunglasses-tile-grid .rubik-swatch__item-wrapper{min-width:0;max-width:100%;align-self:stretch}
    .gr-sunglasses-tile-grid label.gr-sunglasses-image-tile{box-sizing:border-box;width:100%!important;height:100%!important;min-height:150px;max-width:none;margin:0!important;padding:10px 12px;display:flex;flex-direction:column;justify-content:flex-start;gap:8px;white-space:normal;text-align:center;font-size:0!important;line-height:0!important;border:2px solid #dfe5e3;border-radius:6px;background:#fff;color:#243632;overflow:visible;text-overflow:clip;cursor:pointer}
    .gr-sunglasses-tile-grid label.gr-sunglasses-image-tile::before{content:none!important}
    .gr-sunglasses-tile-grid label.gr-sunglasses-image-tile>:not([data-gr-sunglasses-tile-part]):not(.product-form__radio-label--cross-out):not([class*="sold"]):not([class*="unavailable"]){display:none!important}
    .gr-sunglasses-tile-grid label.gr-sunglasses-image-tile>[data-gr-sunglasses-tile-part="image"]{display:block;position:static;flex:none;width:100%;height:76px;object-fit:contain;background:#fff;border:0;border-radius:0;pointer-events:none}
    .gr-sunglasses-tile-grid label.gr-sunglasses-image-tile>[data-gr-sunglasses-tile-part="caption"]{display:block;position:static;width:auto;height:auto;clip:auto;overflow:visible;white-space:normal;text-wrap:pretty;overflow-wrap:anywhere;font-size:13px;line-height:1.4;color:inherit;pointer-events:none}
    .gr-sunglasses-tile-grid input:checked+label.gr-sunglasses-image-tile{border-color:#008080;background:#eef8f6;color:#163a34}
    .gr-sunglasses-tile-grid input:focus-visible+label.gr-sunglasses-image-tile{outline:2px solid #008080;outline-offset:3px}
  `;
  class GrSunglassesImageSwatches extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      try { this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch { return; }
      this.root = this.closest('product-info');
      if (!this.root) return;
      this.controller = new AbortController();
      this.bindings = new Map();
      this.media = new Map(this.data.media.map(image => [String(image.id), image.src]));
      this.scan = this.scan.bind(this);
      this.rootObserver = new MutationObserver(() => this.schedule());
      this.rootObserver.observe(this.root, {childList:true,subtree:true});
      this.root.addEventListener('change', () => this.schedule(), {signal:this.controller.signal});
      customElements.whenDefined('rubik-swatch').then(() => { if (this.isConnected) this.schedule(); });
      this.scan();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.rootObserver?.disconnect();
      this.bindings?.forEach(binding => binding.observer.disconnect());
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.controller = null;
    }
    schedule() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.scan(); });
    }
    scan() {
      if (!this.isConnected) return;
      const surfaces = [...this.root.querySelectorAll('variant-radios'), ...this.root.querySelectorAll('rubik-swatch')].filter(surface => surface.tagName !== 'RUBIK-SWATCH' || String(surface.getAttribute('product-id')) === String(this.data.productId));
      for (const [surface,binding] of this.bindings) if (!surfaces.includes(surface)) { binding.observer.disconnect(); this.bindings.delete(surface); }
      for (const surface of surfaces) {
        const scope = surface.shadowRoot || (surface.tagName === 'VARIANT-RADIOS' ? surface : null);
        if (!scope) continue;
        let binding = this.bindings.get(surface);
        if (!binding || binding.scope !== scope) {
          binding?.observer.disconnect();
          binding = {scope,observer:new MutationObserver(() => this.schedule())};
          this.bindings.set(surface,binding);
          scope.addEventListener('change', () => this.schedule(), {signal:this.controller.signal});
        }
        binding.observer.disconnect();
        if (!scope.querySelector('style[data-gr-sunglasses-tile-style]')) {
          const style = document.createElement('style');
          style.dataset.grSunglassesTileStyle = '1';
          style.textContent = tileCss;
          scope.append(style);
        }
        this.decorate(surface,scope);
        binding.observer.observe(scope,{childList:true,subtree:true,attributes:true,attributeFilter:['checked','data-rubik-variant-id','data-rubik-variant-image','hidden','class']});
      }
    }
    assignedMediaIds(raw, variantId) {
      if (!raw || String(raw.productId) !== String(this.data.productId)) return [];
      if (Number(raw.v) !== 2) {
        const assigned = raw.mediaIdsPerVariantId?.[String(variantId)];
        return Array.isArray(assigned) ? assigned : [];
      }
      const assignments = raw.variants;
      if (!assignments || typeof assignments !== 'object' || Array.isArray(assignments)) return [];
      const valueIds = assignments[String(variantId)];
      if (!Array.isArray(valueIds)) return [];
      const values = Array.isArray(raw.values) ? raw.values : [];
      const valuesById = new Map(values.filter(value => value && value.id != null).map(value => [String(value.id), value.m]));
      const lists = valueIds.map(valueId => valuesById.get(String(valueId)))
        .filter(mediaIds => Array.isArray(mediaIds) && mediaIds.length > 0)
        .map(mediaIds => mediaIds.map(String));
      if (!lists.length) return [];
      const common = new Set((Array.isArray(raw.common) ? raw.common : []).map(String));
      return lists[0].filter(mediaId => !common.has(mediaId) && lists.slice(1).every(mediaIds => mediaIds.includes(mediaId)));
    }
    decorate(surface,scope) {
      let config;
      try { config = JSON.parse(document.querySelector('#rubik-swatch-config')?.textContent || '{}'); } catch { config = {}; }
      if (String(config.productId) !== String(this.data.productId)) config = {};
      const radios = [...scope.querySelectorAll('input[type="radio"]')];
      const checked = new Map(radios.filter(input => input.checked).map(input => [input.dataset.rubikOptionName || input.name,input.value]));
      for (const input of radios) {
        const optionName = input.dataset.rubikOptionName || input.name;
        const position = this.data.options.indexOf(optionName);
        if (position < 0 || /^(size|frame size|lens width|bridge size|fit)$/i.test(optionName)) continue;
        if (optionName === 'Title' && input.value === 'Default Title') continue;
        const label = scope.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (!label) continue;
        const candidates = this.data.variants.filter(variant => variant.options[position] === input.value && variant.available && variant.inventory > 0);
        const score = variant => variant.options.reduce((total,value,index) => total + (index !== position && checked.get(this.data.options[index]) === value ? 1 : 0),0);
        candidates.sort((left,right) => score(right)-score(left));
        const variant = candidates.find(candidate => String(candidate.id) === input.dataset.rubikVariantId) || candidates[0];
        if (!variant) continue;
        const assigned = this.assignedMediaIds(config.variantImages, variant.id);
        const fronts = [...new Set(assigned.map(id => this.media.get(String(id).split('/').at(-1))).filter(src => src && /__shad__fr(?:[_.?]|$)/i.test(src)))];
        const src = fronts.length === 1 ? fronts[0] : variant.image;
        if (!src) continue;
        const grid = label.closest('.rubik-swatch__items') || label.closest('fieldset');
        if (!grid) continue;
        grid.classList.add('gr-sunglasses-tile-grid');
        label.classList.add('gr-sunglasses-image-tile');
        label.dataset.grThumbnailSource = fronts.length === 1 ? 'assigned-front' : 'variant-featured';
        let image = label.querySelector('[data-gr-sunglasses-tile-part="image"]');
        if (!image) {
          image = document.createElement('img');
          image.dataset.grSunglassesTilePart = 'image';
          image.alt = '';
          image.width = 360;
          image.height = 180;
          image.loading = 'lazy';
          image.decoding = 'async';
          label.append(image);
        }
        if (image.getAttribute('src') !== src) image.setAttribute('src',src);
        let caption = label.querySelector('[data-gr-sunglasses-tile-part="caption"]');
        if (!caption) {
          caption = document.createElement('span');
          caption.dataset.grSunglassesTilePart = 'caption';
          caption.setAttribute('aria-hidden','true');
          label.append(caption);
        }
        if (caption.textContent !== input.value) caption.textContent = input.value;
        if (!input.hasAttribute('aria-label')) input.setAttribute('aria-label',`${optionName}: ${input.value}`);
        surface.dataset.grSunglassesImageTiles = '1';
      }
    }
  }
  customElements.define('gr-sunglasses-image-swatches',GrSunglassesImageSwatches);
}
  } catch(e) { console.error(e); }
})();

})();
